import { useMemo } from 'react';
import { useGetManyWarehouses } from 'api/warehouses/use-get-many-warehouses';
import { findWarehouseById } from 'shared/utils/warehouses/find-warehouse-by-id';

export const useRouteWarehouses = (warehouseIds: number[]) => {
  const { data: warehouses, isLoading } = useGetManyWarehouses();

  const routeWarehouses = useMemo(() => {
    if (!warehouses) return [];

    return warehouseIds.map((id) => findWarehouseById(id, warehouses));
  }, [warehouseIds, warehouses]);

  return { routeWarehouses, isLoading };
};
